import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { handleGoogleLogin, handleSignOut, getCurrentUser } from './Auth'; 
import { useNavigate } from 'react-router-dom';
import logo from '../assets/ovguru.png';

const Navbar = ({ user, setUser }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); 
  const navigate = useNavigate(); 

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLoginClick = async () => {
    await handleGoogleLogin();
    setUser(getCurrentUser()); 
    navigate('/home'); 
  };

  const handleSignOutClick = async () => {
    await handleSignOut();
    setUser(null);
    navigate('/'); 
  };

  const handleLogoClick = () => {
    navigate('/home');
  };

  return (
    <AppBar position="static" sx={{ 
      background: 'linear-gradient(90deg, #FFFFFF 0%, #214E5CFF 100%)',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', 
    }}>
      <Toolbar>
        {isMobile ? (
          <>
            {/* Mobile View Menu Icon */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuClick}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleMenuClose}>Categories</MenuItem>
              {user ? (
                <MenuItem onClick={handleSignOutClick}>Sign Out</MenuItem>
              ) : (
                <>
                  <MenuItem onClick={handleLoginClick}>Log In</MenuItem>
                  <MenuItem onClick={handleMenuClose}>Sign Up</MenuItem>
                </>
              )}
            </Menu>
          </>
        ) : (
          <>
            <l onClick={handleLogoClick}>
              <img
                src={logo}
                alt="Logo"
                style={{ height: 'auto', width: '55px', cursor: 'pointer' }}
              />
            </l>

            {/* Search Bar 
            <Box sx={{ flexGrow: 3, mx: 4 }}>
              <TextField
                variant="outlined"
                placeholder="Search for anything"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  background: '#fff',
                  borderRadius: 5,
                  '& .MuiOutlinedInput-root': {
                    height: 35,
                    padding: 0,
                    '& fieldset': {
                      border: 'none',
                    },
                    '& input': {
                      padding: '8px 8px 8px 15px', 
                    },
                  },
                }}
              />
            </Box>
              */}
            {/* Cart Button */}
            <IconButton color="inherit" sx={{ ml: 1 }}>
              {/*<ShoppingCartIcon />*/}
            </IconButton>

            {/* User Info and Log In/Sign Out Button */}
            <Box sx={{ flexGrow: 1 }} /> {/* Added Box to take up remaining space */}
            {user ? (
              <>
                <Typography
                  variant="body1"
                  sx={{ color: '#fff', mx: 2, fontWeight: 'bold', textTransform: 'none' }}
                >
                  {user.userName}
                </Typography>
                <Button
                  variant="outlined"
                  sx={{
                    color: '#fff',
                    borderColor: '#fff',
                    mx: 1,
                    textTransform: 'none', 
                    '&:hover': {
                      borderColor: '#fff',
                      background: 'linear-gradient(90deg, #FF8E53 0%, #FE6B8B 100%)',
                    },
                  }}
                  onClick={handleSignOutClick} 
                >
                  Sign Out
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  sx={{
                    color: '#fff',
                    borderColor: '#fff',
                    mx: 2,
                    textTransform: 'none', 
                    '&:hover': {
                      borderColor: '#fff',
                      background: 'linear-gradient(90deg, #FF8E53 0%, #FE6B8B 100%)',
                    },
                  }}
                  onClick={handleLoginClick} 
                >
                  Log In
                </Button>
              </>
            )}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
